import dayjs from 'dayjs';
import { ICompany } from 'app/shared/model/company.model';

export interface IKpiPreset {
  id?: number;
  name?: string | null;
  createdStart?: string | null;
  createdEnd?: string | null;
  standard?: boolean | null;
  deleted?: boolean | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IKpiPreset> = {
  standard: false,
  deleted: false,
};
